import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import FormGroup from "../../elements/formElements/FormGroup";
import Select from "../../elements/formElements/Select";
import axios from "../../services/MyAxios";

function ResellerForm({ resellerData, errors, action }) {
    const [reseller, setReseller] = useState({
        country: '',
        state: '',
        phone_country: '',
        phone: '',
        email: '',
        password: '',
        name: '',
        last_name: '',
    });
    const history = useHistory();

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);

    useEffect(() => {
        if (resellerData) {
            let reseller = {
                country: resellerData.country ?? '',
                state: resellerData.state ?? '',
                phone_country: resellerData.phone_country ?? '',
                phone: resellerData.phone ?? '',
                email: resellerData.email ?? '',
                password: '',
                name: resellerData.name ?? '',
                last_name: resellerData.last_name ?? '',
            };
            setReseller(reseller);
        }
    }, [resellerData]);

    useEffect(() => {
        axios.get('/crea/api/countries').then((response) => {
            setCountries(response.data);
        });
    }, []);

    useEffect(() => {
        if (reseller.country) {
            axios.get('/crea/api/states/' + reseller.country).then((response) => {
                setStates(response.data);
            });
        } else {
            setStates([]);
        }
    }, [reseller.country]);

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        action(reseller);
    }

    function cancel() {
        history.push('/resellers');
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <Select
                field={'phone_country'}
                value={reseller.phone_country}
                label={'Phone country'}
                options={countries}
                error={getErrorFor('phone_country')}
                handleChange={(event) =>
                    setReseller({ ...reseller, phone_country: event.target.value })
                }
            />

            <FormGroup
                type={'text'}
                field={'phone'}
                value={reseller.phone}
                label={'Phone'}
                error={getErrorFor('phone')}
                handleChange={(event) => setReseller({ ...reseller, phone: event.target.value })}
            />

            <Select
                field={'country'}
                value={reseller.country}
                label={'Country'}
                options={countries}
                error={getErrorFor('country')}
                handleChange={(event) => setReseller({ ...reseller, country: event.target.value })}
            />

            <Select
                field={'state'}
                value={reseller.state}
                label={'State'}
                options={states}
                error={getErrorFor('state')}
                handleChange={(event) => setReseller({ ...reseller, state: event.target.value })}
            />

            <FormGroup
                type={'email'}
                field={'email'}
                value={reseller.email}
                label={'Email'}
                error={getErrorFor('email')}
                handleChange={(event) => setReseller({ ...reseller, email: event.target.value })}
                disableAutofill={true}
            />

            <FormGroup
                type={'password'}
                field={'password'}
                value={reseller.password}
                label={'Password'}
                error={getErrorFor('password')}
                handleChange={(event) => setReseller({ ...reseller, password: event.target.value })}
                disableAutofill={true}
            />

            <FormGroup
                type={'text'}
                field={'name'}
                value={reseller.name}
                label={'Name'}
                error={getErrorFor('name')}
                handleChange={(event) => setReseller({ ...reseller, name: event.target.value })}
                disableAutofill={true}
            />

            <FormGroup
                type={'text'}
                field={'last_name'}
                value={reseller.last_name}
                label={'Last name'}
                error={getErrorFor('last_name')}
                handleChange={(event) => setReseller({ ...reseller, last_name: event.target.value })}
                disableAutofill={true}
            />

            <button type="button" onClick={cancel} className="btn btn-secondary">Cancel</button>
            <button type="submit" className="btn btn-primary">Save</button>
        </form>
    );
}

export default ResellerForm;
